import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";
import {
    getCalculatedAmountOut,
    getDeliberateRate,
    normalize
} from "./comparison.resolver";
import {LabelColumn} from "./labelColumn/labelColumn";
import {OurColumn} from "./ourColumn/ourColumn";
import {OtherColumn} from "./otherColumn/otherColumn";
import {isMobile} from "app/lib/dimesions";
import {ComparisonTabs} from "./tabs/tabs";
import {Translate} from "app/services/translate";

@connect((state) => {
    return {
        calculator: state.calculator
    };
})

export class Comparison extends Component {
    static get propTypes() {
        return {
            calculator: PropTypes.object,
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            current: 'easysend',
        };

        this.handleTabClick = this.handleTabClick.bind(this);
    }

    handleTabClick(type) {
        this.setState({current: type});
    }

    render() {
        const {
            inProgress,
            exchange,
            amountIn,
            availableDeliveryMethods,
        } = this.props.calculator;
        const {current} = this.state;

        if (inProgress && !availableDeliveryMethods) {
            return <div className="sk-circle"/>;
        }

        const competitor = Translate('comparison_values_bank');
        const tabs = isMobile() ? <ComparisonTabs competitor={competitor} onTabClick={this.handleTabClick}/> : null;

        const amount = normalize(amountIn);
        const deliberateRate = getDeliberateRate(exchange);
        const comparisonAmounts = {
            our: getCalculatedAmountOut(amount, exchange),
            other: getCalculatedAmountOut(amount, deliberateRate)
        };

        return (

            <div className="comparison-wrapper">
                {tabs}
                {
                    <LabelColumn amount={amount}/>
                }
                { (isMobile() ? current === 'easysend' : true) &&
                    <OurColumn
                        availableDeliveryMethods={availableDeliveryMethods}
                        exchange={exchange}
                        comparisonAmounts={comparisonAmounts}/>
                }
                { (isMobile() ? current === 'competitor' : true) &&
                    <OtherColumn
                        competitor={competitor}
                        deliberateRate={deliberateRate}
                        comparisonAmounts={comparisonAmounts}/>
                }
            </div>
        );
    }
}
